import { get } from '../utils/httpClient'
import { GetBalanceResponse } from './types'
import { getRedDataApiPaths } from '../config'

export const apiGetBalance = async () => {
  return (await get(`${getRedDataApiPaths().RED_API_BALANCE}`, true)) as GetBalanceResponse
}
